const Detached: any = (
  style = {},
  fill = '#000',
  width = '100%',
  height = '100%',
  viewBox = '0 0 64 48',
) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M1.00107 18.0002C0.699072 18.0002 0.401071 17.8642 0.204071 17.6062C-0.129929 17.1672 -0.0449285 16.5392 0.393071 16.2042L21.3931 0.2042C21.8341 -0.1308 22.4591 -0.0438007 22.7951 0.393199C23.1291 0.832199 23.0441 1.4602 22.6061 1.7952L1.60607 17.7952C1.42507 17.9342 1.21207 18.0002 1.00107 18.0002Z"
      fill={fill}
    />
    <path
      d="M1.00107 22.0003C0.699072 22.0003 0.401071 21.8643 0.204071 21.6063C-0.129929 21.1673 -0.0449285 20.5393 0.393071 20.2043L21.3931 4.20426C21.8341 3.86926 22.4591 3.95525 22.7951 4.39325C23.1291 4.83225 23.0441 5.46025 22.6061 5.79525L1.60607 21.7953C1.42507 21.9343 1.21207 22.0003 1.00107 22.0003Z"
      fill={fill}
    />
    <path
      d="M44.312 19.0002C44.101 19.0002 43.888 18.9342 43.707 18.7962L21.394 1.79623C20.956 1.46123 20.871 0.833231 21.205 0.394231C21.54 -0.0437686 22.166 -0.129769 22.607 0.205231L44.92 17.2052C45.358 17.5402 45.443 18.1682 45.109 18.6072C44.911 18.8642 44.613 19.0002 44.312 19.0002Z"
      fill={fill}
    />
    <path
      d="M42.999 22.0002C42.788 22.0002 42.575 21.9342 42.394 21.7962L21.394 5.79623C20.956 5.46123 20.871 4.83323 21.205 4.39423C21.54 3.95623 22.166 3.87023 22.607 4.20523L43.607 20.2052C44.045 20.5402 44.13 21.1682 43.796 21.6072C43.599 21.8642 43.301 22.0002 42.999 22.0002Z"
      fill={fill}
    />
    <path
      d="M63 19.0002H44.313C43.76 19.0002 43.313 18.5532 43.313 18.0002C43.313 17.4472 43.76 17.0002 44.313 17.0002H63C63.553 17.0002 64 17.4472 64 18.0002C64 18.5532 63.553 19.0002 63 19.0002Z"
      fill={fill}
    />
    <path
      d="M1 22.0002C0.447 22.0002 0 21.5532 0 21.0002V17.0002C0 16.4472 0.447 16.0002 1 16.0002C1.553 16.0002 2 16.4472 2 17.0002V21.0002C2 21.5532 1.553 22.0002 1 22.0002Z"
      fill={fill}
    />
    <path
      d="M63 22.0002H43C42.447 22.0002 42 21.5532 42 21.0002C42 20.4472 42.447 20.0002 43 20.0002H63C63.553 20.0002 64 20.4472 64 21.0002C64 21.5532 63.553 22.0002 63 22.0002Z"
      fill={fill}
    />
    <path
      d="M63 22.0002C62.447 22.0002 62 21.5532 62 21.0002V18.0002C62 17.4472 62.447 17.0002 63 17.0002C63.553 17.0002 64 17.4472 64 18.0002V21.0002C64 21.5532 63.553 22.0002 63 22.0002Z"
      fill={fill}
    />
    <path
      d="M3 48.0003C2.447 48.0003 2 47.5533 2 47.0003V19.4773C2 18.9243 2.447 18.4773 3 18.4773C3.553 18.4773 4 18.9243 4 19.4773V47.0003C4 47.5533 3.553 48.0003 3 48.0003Z"
      fill={fill}
    />
    <path
      d="M41 48.0003C40.447 48.0003 40 47.5533 40 47.0003V19.4773C40 18.9243 40.447 18.4773 41 18.4773C41.553 18.4773 42 18.9243 42 19.4773V47.0003C42 47.5533 41.553 48.0003 41 48.0003Z"
      fill={fill}
    />
    <path
      d="M61 48.0002C60.447 48.0002 60 47.5532 60 47.0002V21.0002C60 20.4472 60.447 20.0002 61 20.0002C61.553 20.0002 62 20.4472 62 21.0002V47.0002C62 47.5532 61.553 48.0002 61 48.0002Z"
      fill={fill}
    />
    <path
      d="M63.0011 19.0003C62.6651 19.0003 62.3371 18.8313 62.1481 18.5243L54.1481 5.5243C53.8591 5.0533 54.0051 4.4373 54.4751 4.1483C54.9471 3.8583 55.5621 4.0043 55.8511 4.4753L63.8511 17.4753C64.1401 17.9463 63.9941 18.5623 63.5241 18.8513C63.3601 18.9523 63.1801 19.0003 63.0011 19.0003Z"
      fill={fill}
    />
    <path
      d="M55 6.00024H27.25C26.697 6.00024 26.25 5.55324 26.25 5.00024C26.25 4.44724 26.697 4.00024 27.25 4.00024H55C55.553 4.00024 56 4.44724 56 5.00024C56 5.55324 55.553 6.00024 55 6.00024Z"
      fill={fill}
    />
    <path
      d="M22 25.0002C19.243 25.0002 17 22.7572 17 20.0002C17 17.2432 19.243 15.0002 22 15.0002C24.757 15.0002 27 17.2432 27 20.0002C27 22.7572 24.757 25.0002 22 25.0002ZM22 17.0002C20.346 17.0002 19 18.3462 19 20.0002C19 21.6542 20.346 23.0002 22 23.0002C23.654 23.0002 25 21.6542 25 20.0002C25 18.3462 23.654 17.0002 22 17.0002Z"
      fill={fill}
    />
    <path
      d="M19 48.0002C18.447 48.0002 18 47.5532 18 47.0002V35.0002C18 34.4472 18.447 34.0002 19 34.0002C19.553 34.0002 20 34.4472 20 35.0002V47.0002C20 47.5532 19.553 48.0002 19 48.0002Z"
      fill={fill}
    />
    <path
      d="M25 36.0002H19C18.447 36.0002 18 35.5532 18 35.0002C18 34.4472 18.447 34.0002 19 34.0002H25C25.553 34.0002 26 34.4472 26 35.0002C26 35.5532 25.553 36.0002 25 36.0002Z"
      fill={fill}
    />
    <path
      d="M25 48.0002C24.447 48.0002 24 47.5532 24 47.0002V35.0002C24 34.4472 24.447 34.0002 25 34.0002C25.553 34.0002 26 34.4472 26 35.0002V47.0002C26 47.5532 25.553 48.0002 25 48.0002Z"
      fill={fill}
    />
    <path
      d="M15 39.0002H7C6.447 39.0002 6 38.5532 6 38.0002V30.0002C6 29.4472 6.447 29.0002 7 29.0002H15C15.553 29.0002 16 29.4472 16 30.0002V38.0002C16 38.5532 15.553 39.0002 15 39.0002ZM8 37.0002H14V31.0002H8V37.0002Z"
      fill={fill}
    />
    <path
      d="M37 39.0002H29C28.447 39.0002 28 38.5532 28 38.0002V30.0002C28 29.4472 28.447 29.0002 29 29.0002H37C37.553 29.0002 38 29.4472 38 30.0002V38.0002C38 38.5532 37.553 39.0002 37 39.0002ZM30 37.0002H36V31.0002H30V37.0002Z"
      fill={fill}
    />
    <path
      d="M55 39.0002H47C46.447 39.0002 46 38.5532 46 38.0002V30.0002C46 29.4472 46.447 29.0002 47 29.0002H55C55.553 29.0002 56 29.4472 56 30.0002V38.0002C56 38.5532 55.553 39.0002 55 39.0002ZM48 37.0002H54V31.0002H48V37.0002Z"
      fill={fill}
    />
    <path
      d="M22 25.0002C21.447 25.0002 21 24.5532 21 24.0002V16.0002C21 15.4472 21.447 15.0002 22 15.0002C22.553 15.0002 23 15.4472 23 16.0002V24.0002C23 24.5532 22.553 25.0002 22 25.0002Z"
      fill={fill}
    />
    <path
      d="M26 21.0002H18C17.447 21.0002 17 20.5532 17 20.0002C17 19.4472 17.447 19.0002 18 19.0002H26C26.553 19.0002 27 19.4472 27 20.0002C27 20.5532 26.553 21.0002 26 21.0002Z"
      fill={fill}
    />
    <path
      d="M63 48.0002H1C0.447 48.0002 0 47.5532 0 47.0002C0 46.4472 0.447 46.0002 1 46.0002H63C63.553 46.0002 64 46.4472 64 47.0002C64 47.5532 63.553 48.0002 63 48.0002Z"
      fill={fill}
    />
    <path
      d="M55.924 14.0002H43.75C43.197 14.0002 42.75 13.5532 42.75 13.0002C42.75 12.4472 43.197 12.0002 43.75 12.0002H55.924C56.477 12.0002 56.924 12.4472 56.924 13.0002C56.924 13.5532 56.477 14.0002 55.924 14.0002Z"
      fill={fill}
    />
    <path
      d="M53.462 10.0002H38.5C37.947 10.0002 37.5 9.55324 37.5 9.00024C37.5 8.44724 37.947 8.00024 38.5 8.00024H53.462C54.015 8.00024 54.462 8.44724 54.462 9.00024C54.462 9.55324 54.015 10.0002 53.462 10.0002Z"
      fill={fill}
    />
    <path
      d="M15 34.0002H7C6.447 34.0002 6 33.5532 6 33.0002C6 32.4472 6.447 32.0002 7 32.0002H15C15.553 32.0002 16 32.4472 16 33.0002C16 33.5532 15.553 34.0002 15 34.0002Z"
      fill={fill}
    />
    <path
      d="M55 34.0002H47C46.447 34.0002 46 33.5532 46 33.0002C46 32.4472 46.447 32.0002 47 32.0002H55C55.553 32.0002 56 32.4472 56 33.0002C56 33.5532 55.553 34.0002 55 34.0002Z"
      fill={fill}
    />
    <path
      d="M37 34.0002H29C28.447 34.0002 28 33.5532 28 33.0002C28 32.4472 28.447 32.0002 29 32.0002H37C37.553 32.0002 38 32.4472 38 33.0002C38 33.5532 37.553 34.0002 37 34.0002Z"
      fill={fill}
    />
  </svg>
)

export default Detached
